<div class="payment-method-outer">
    <div class="payment-method">
        <div class="payment-text">
            <p>Please set the default payment method that will be used for future transactions.
            </p>
        </div>
        <div class="add-btn cencle-btn">
            <p-button type="submit" label="Add New" (onClick)="addPaymentMethod()"></p-button>

        </div>

    </div>

    <hr class="custom-border" />

    <div class="credit-card" *ngIf="cardPaymentList.length> 0">
        <div class="credit-heading">
            <h4>Cards </h4>

        </div>
        <div class="visa-scroll">
            <div class="main-visa" *ngFor="let data of cardPaymentList">

<div class="holder-details">
                    <div class="visa-outer-left">
                        <p-radioButton name="" [(ngModel)]="paymentMethodSelected" [value]="data"
                            (ngModelChange)="SetDefualtPaymentMethod(data)" inputId="ingredient1" />
                        <span class="card-name">{{data.brand}}</span>
                        <p>XXXXXXXXXXXX{{data.last4}}</p>
                    </div>
                    <div class="card-expiry">
                        <div class="expiry-outer">
                            <h5>Expiry Date:</h5>
                            <p>{{getMonthName(data.expMonth)}} {{data.expYear}}</p>
                        </div>
                        <div class="expiry-outer expiry-text">
                            <h5>Card Holder Name:</h5>

                            <p>{{data.cardHolderName}}</p>

                        </div>
                    </div>
                </div>
                <div *ngIf="!data.isDefaultPaymentMethod" class="dot-outer">
                    <img src="../../../../assets/images/dashboard-dot.svg"
                        (click)="activeItem = data;addDefulatDeletePaymentMethod(data);menu.toggle($event)" alt=""/>
                </div>
            </div>
        </div>
    </div>
    <div class="ech-details credit-card" *ngIf="bankPaymentList.length >0">
        <div class="credit-heading">
            <h4>Bank Accounts</h4>

        </div>
        <div class="visa-scroll">
            <div class="main-visa"  *ngFor="let data of bankPaymentList">

<div class="holder-details">
                    <div class="visa-outer-left">
                        <p-radioButton [(ngModel)]="paymentMethodSelected" name=""
                        (ngModelChange)="SetDefualtPaymentMethod(data)" [value]="data" inputId="ingredient1" />

                    <h5>Account Number:</h5>
                    <p>XXXXXXXXXXXX{{data.last4}}</p>
                    </div>
                    <div class="card-expiry">
                        <div class="expiry-inner-outer">
                            <h5>Bank Name:</h5>
                            <p>{{data.bankName}}</p>
                        </div>
                        <div class="expiry-inner-outer expiry-text">
                            <h5>Account Holder Name:</h5>
                            <p>{{data.accountHolderName}}</p>

                        </div>
                    </div>
                </div>
                <div *ngIf="!data.isDefaultPaymentMethod" class="dot-outer">
                    <img src="../../../../assets/images/dashboard-dot.svg"
                    (click)="activeItem = data;addDefulatDeletePaymentMethod(data);menu.toggle($event)" alt=""/>
                </div>
            </div>
        </div>

    </div>

</div>

<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>